import StoreNewspaper from './StoreNewspaper'

export default StoreNewspaper
